// account/AuthContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { getToken, clearToken } from '../utils/token';
import apiService from '../services/ApiService';
import { useOrder } from '../order/OrderContext'; //

const AuthContext = createContext();

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within AuthProvider');
    }
    return context;
};

export const AuthProvider = ({ children }) => {
    const [authState, setAuthState] = useState({
        isAuthenticated: false,
        userEmail: null,
        loading: true
    });

    // Dostęp do OrderContext (może być null jeśli AuthProvider jest wyżej w drzewie)
    let orderContext = null;
    try {
        orderContext = useOrder();
    } catch (error) {
        // OrderProvider nie jest dostępny wyżej w drzewie - to OK
    }

    // Sprawdzenie stanu autoryzacji przy starcie aplikacji
    useEffect(() => {
        checkAuthStatus();
    }, []);

    const checkAuthStatus = async () => {
        const token = getToken();

        if (!token) {
            setAuthState({
                isAuthenticated: false,
                userEmail: null,
                loading: false
            });
            return;
        }

        try {
            // Sprawdź czy token jest ważny przez wywołanie API
            const result = await apiService.getUserData();

            if (result.wpEmail) {
                setAuthState({
                    isAuthenticated: true,
                    userEmail: result.wpEmail,
                    loading: false
                });
            } else {
                // Token nieprawidłowy
                logout();
            }
        } catch (error) {
            // Błąd - token prawdopodobnie nieważny
            logout();
        }
    };

    const login = async (token, email) => {
        setAuthState({
            isAuthenticated: true,
            userEmail: email,
            loading: false
        });

        // NOWE: Wyślij CustomEvent userLoggedIn (spójność z LoginPage)
        window.dispatchEvent(new CustomEvent('userLoggedIn', {
            detail: { email }
        }));
    };




    const logout = async () => {
        clearToken();

        // Wyślij event userLoggedOut
        window.dispatchEvent(new Event('userLoggedOut'));

        // Wyczyść sesję po wylogowaniu
        if (orderContext?.clearSession) {
            await orderContext.clearSession();
        } else {
            // Fallback - wyczyść localStorage ręcznie
            localStorage.removeItem('gh3d_quote_session');
        }

        setAuthState({
            isAuthenticated: false,
            userEmail: null,
            loading: false
        });
    };

    const value = {
        ...authState,
        login,
        logout,
        checkAuthStatus
    };

    return (
        <AuthContext.Provider value={value}>
        {children}
        </AuthContext.Provider>
    );
};
